import React from 'react';
import helpers from '../../Utils/helpers'
import { useTranslation } from 'react-i18next';

const LeadsActionHistoryComments = ({ actionHistory }) => {
    const { t } = useTranslation();

    if (!actionHistory || actionHistory.length < 1) {
        return null;
    }

    return (
        <div className="form-group">
            <label>{t('leadactionhistory.leadactionhistory')}</label>
            <table className="appointment-comment table">
                <tbody>
                    {actionHistory.map((action, index) => {
                        return <tr key={index}>
                            <td>
                                <span className="date text-disabled">{helpers.formatDate(action.date)} </span>
                                <span className="author text-primary">{action.author} : </span>
                                <span className="comment">{action.action}</span>
                            </td>
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default LeadsActionHistoryComments;